import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { CampusProductCategory } from '../ProductSelector/CampusProductCategory';
import { RealCampusProductCard } from '../RealCampus/RealCampusProductCard';
import { CampusBrandCard } from '../ProductSelector/CampusBrandCard';
import { ProductSwatch } from '../ProductSelector/ProductSwatch';
import { CloseX } from '../Components/CloseX';
import { browserHistory } from 'react-router';
import { ScreenDoor } from '../Components/ScreenDoor';
import { CampusHeader } from '../Components/CampusHeader';
import { CampusFooter } from '../Components/CampusFooter';
import { CampusFeedback } from './CampusFeedback';
import { FilterGroup } from '../Components/FilterGroup';
import { FilterBubble } from '../Components/FilterBubble';

const DIVISION: string = 'Campus';

// ── Hardcoded Outer Banks 7089 (Double Mercerized Mock Neck Tee) ───────────
// Temporary product; remove once it is live in the API.
const OB_IMG_1 = Tgcc.ResolveUrl('~/images/ob_gdye_tee_black_1.png');
const OB_IMG_2 = Tgcc.ResolveUrl('~/images/ob_gdye_tee_black_2.png');

const OB_BRAND: Tgcc.ProductBrand = {
    brand: 'Outer Banks',
    image: '',
    thumbnail: '',
    priority: 0
};

const OB_PRODUCT: Tgcc.Product = {
    brand: 'Outer Banks',
    style: '7089',
    colorName: 'Black',
    colorCode: 'BLK',
    description: 'Classic Outer Bank Lighthouse branding.',
    features: '100% ring-spun cotton.',
    specs: 'Sizes S–3XL. Pre-shrunk. Side-seamed construction.',
    image: OB_IMG_1,
    thumbnail: OB_IMG_1,
    size: null,
    displayIndex: 0,
    favorite: false,
    designation: null,
    designationOrdinal: 0,
    colorCount: 12,
    sizes: []
};

const OB_PRODUCT_VIEW2: Tgcc.Product = {
    ...OB_PRODUCT,
    colorName: 'Black',
    colorCode: 'BLK2',
    image: OB_IMG_2,
    thumbnail: OB_IMG_2,
    displayIndex: 1
};

// Single swatch for display; both images are surfaced in the detail panel.
// Both entries kept so the zoom popup's prev/next arrows can cycle between them.
const OB_STYLE_SET: Tgcc.Product[] = [OB_PRODUCT, OB_PRODUCT_VIEW2];

/** Returns true when the active filter state should include the hardcoded OB product. */
function shouldShowOBProduct(categories: number[], brands: string[]): boolean {
    if (brands && brands.length > 0 && brands.indexOf('Outer Banks') === -1) return false;
    if (!categories || categories.length === 0) return true;
    // 100% Cotton SS category ID (1)
    return categories.indexOf(1) > -1;
}
// ──────────────────────────────────────────────────────────────────────────

const categoryContainerOuterStyle: CSSProperties = {
    position: 'relative',
    width: 'auto',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
};
const categoryContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    textTransform: 'uppercase',
    backgroundColor: '#E9E6E6',
    marginBottom: '15px',
    flexShrink: 0,
};
const searchStyle: CSSProperties = {
    display: 'none',
    alignSelf: 'center',
    fontFamily: 'CenturyGothic',
    fontSize: '12px',
    letterSpacing: '6px',
    backgroundColor: 'white',
    textAlign: 'center',
    border: '1px solid #CCCCCC',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '200px',
    '@media (max-width:1024px) and (max-height:1366px)': {
        margin: 'auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin: 'auto'
    },
    '@media (max-width:360px)': {
        lineHeight: '25px',
    },
    '@media (max-width:320px)': {
        width: '265px',
        lineHeight: '20px'
    }
};
/*remove flexWrap for straight line list...looks cool*/
const catalogOuterStyle: CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%',
    flexGrow: 2,
    overflowY: 'visible',
    position: 'relative',
    justifyContent: 'center'
}
const sortSelectStyle: CSSProperties = {
    position: 'absolute',
    left: 45,
    top: 0,
    marginTop: '-30px',
    border: 0,
    padding: '3px',
    backgroundColor: '#E9E6E6',
    color: '#616060'
}
const catalogStyle: CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flexGrow: 2,
    overflowY: 'auto',
    position: 'relative',
    justifyContent: 'center'
};
const searchFormStyle: CSSProperties = {
    textAlign: 'center',
    marginBottom: '0px'
}
const searchBtn: CSSProperties = {
    padding: '0px',
    backgroundImage: 'url(' + Tgcc.ResolveUrl('~/images/search_button.png') + ')',
    width: '25px',
    height: '27px',
    backgroundSize: 'cover',
    marginTop: '-29px',
    float: 'right',
    marginRight: '40px',
    display: 'none'
}

const contentDiv: CSSProperties = {
    display: 'flex',
    margin: '50px auto 0px auto',
    width: '80%',
    alignItems: 'start'
}

const backToProofBtn: CSSProperties = {
    height: '35px',
    cursor: 'pointer',
    lineHeight: '35px',
    padding: '5px 25px 0 15px',
    textAlign: 'Left',
    fontFamily: 'Lulo',
    backgroundColor: '#E9E6E6',
    color: '#616060',
    display: 'inline-block',
    marginBottom: '10px',
    borderRadius: '10px'
}

const activeFiltersStyle: CSSProperties = {
    width: '100%',
    margin: '1px 3px 3px 10px'
}

const clearAllStyle: CSSProperties = {
    fontSize: '12px',
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '8px',
    lineHeight: '15px',
    display: 'block',
    float: 'left',
    marginLeft: '10px'
}

const emailUs: CSSProperties = {
    display: 'inline-block'
}

class ProductSelectProps extends Tgcc.BaseProps {
    proof: Tgcc.Proof;
    searchFilter: string;
}

type StateType = {
    productReqTime: number,
    filterReqTime: number,
    filter: string,
    categories: number[],
    brand: string[],
    product: Tgcc.Product,
    selectedSwatch: Tgcc.Product,
    zoomProduct: Tgcc.Product,
    ProductCategories: Tgcc.ProductCategory[],
    Products: Tgcc.Product[],
    ProductBrands: Tgcc.ProductBrand[],
    BrandsDict: any,
    StyleSet: Tgcc.Product[],
    documentOverflow: string,
    priceCategory: string[],
    genderAge: string[],
    sleeve: string[],
    styleType: string[],
    fabric: string[],
    weight: string[],
    uniqueSize: string[],
    newItem: boolean,
    favorite: boolean,
    sort: string,
    iswaiting: boolean,
    filterCounts: Map<string, Map<string, number>>
}

class _CampusProductListView extends React.Component<ProductSelectProps, any> {

    selectedCategory: string = null;
    selectedBrand: Tgcc.ProductBrand = null;
    state: StateType = {
        productReqTime: 0,
        filterReqTime: 0,
        filter: null,
        categories: null,
        brand: null,
        product: null,
        selectedSwatch: null,
        zoomProduct: null,
        ProductCategories: null,
        Products: null,
        ProductBrands: null,
        BrandsDict: null,
        StyleSet: null,
        documentOverflow: null,
        priceCategory: null,
        genderAge: null,
        sleeve: null,
        styleType: null,
        fabric: null,
        weight: null,
        uniqueSize: null,
        newItem: false,
        favorite: false,
        sort: Tgcc.SortOrders.Default,
        iswaiting: true,
        filterCounts: new Map<string, Map<string, number>>()
    }

    componentWillUnmount() {
        document.body.style.overflow = this.state.documentOverflow;
    }

    componentWillMount() {
        this.setState({ documentOverflow: document.body.style.overflow });
        document.body.style.overflow = 'hidden';
        this.clearState();
        // creates initial product list
        if (!this.props.proof) {
            this.props.dispatch({ type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof() });
        }
        if (this.props.params.brand == "Bella _plus_ Canvas") {
            this.toggleFilterValue("brand", "Bella + Canvas", true)
        }
        else if (this.props.params.brand) {
            this.toggleFilterValue('brand', this.props.params.brand, true);
        }
        if (!this.props.params.category && !this.props.params.brand) {
            this.toggleFilterValue('recommendation', 'favorite', false);
        }
        
        if (this.props.params.brand && this.props.params.style && this.props.params.color) {
            TgccRequest.getProduct(this.props.params.brand, this.props.params.style, this.props.params.color, this.loadProduct, () => { })
        }

        TgccRequest.getProductCategories(DIVISION, (categories: Tgcc.ProductCategory[]) => this.productCategoriesLoaded(categories));
        TgccRequest.getProductBrands(DIVISION, (brands: Tgcc.ProductBrand[]) => this.productBrandsLoaded(brands));
    }

    componentDidMount() {
        var tag = document.getElementById('campusProducts');
        tag.scrollIntoView(false);
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    clearState = () => {
        this.setState({
            productReqTime: 0,
            filterReqTime: 0,
            filter: null,
            categories: null,
            brand: null,
            product: null,
            selectedSwatch: null,
            zoomProduct: null,
            ProductCategories: null,
            Products: null,
            ProductBrands: null,
            BrandsDict: null,
            StyleSet: null,
            priceCategory: null,
            genderAge: null,
            sleeve: null,
            styleType: null,
            fabric: null,
            weight: null,
            newItem: false,
            favorite: false,
            sort: null
        });
        this.props.dispatch({ type: Tgcc.StateAction.FilterProductsByCategory, payload: null })
    }
    loadProduct = (product: Tgcc.Product) => {
        this.handleProductSelection(product[0]);
    }
    productCategoriesLoaded(categories: Tgcc.ProductCategory[]) {
        this.setState({ ProductCategories: categories });
        if (this.props.params.category) {
            this.setState({ favorite: false })
        }
        if(this.state.ProductCategories){
            switch(this.props.params.category){
                case "Pocket":
                    this.toggleFilterValue('categories',29,true);
                    this.toggleFilterValue('categories',19,true);
                break;
                case "NPSS":
                    this.toggleFilterValue('categories',1,true);
                    this.toggleFilterValue('categories',5,true);
                break;
                case "NPLS":
                    this.toggleFilterValue('categories',23,true);
                break;
                case "Polo":
                    this.toggleFilterValue('categories',33,true);
                break;
                case "Tank":
                    this.toggleFilterValue('categories',38,true);
                break;
                case "Hoodies":
                    this.toggleFilterValue('categories',15,true);
                break;
                case "Crewneck":
                    this.toggleFilterValue('categories',7,true);
                break;
                case "Hats":
                    this.toggleFilterValue('categories',11,true);
                break;
            }
        }    
        
    }
    productBrandsLoaded(brands: Tgcc.ProductBrand[]) {
        var brandsDict = {};
        brands.forEach((brand: Tgcc.ProductBrand) => brandsDict[brand.brand] = brand);
        brandsDict['Outer Banks'] = OB_BRAND;
        this.setState({ ProductBrands: brands, BrandsDict: brandsDict });
    }
    productsLoaded(products: Tgcc.Product[]) {
        const allProducts = shouldShowOBProduct(this.state.categories, this.state.brand)
            ? [OB_PRODUCT, ...products]
            : products;
        this.setState({ Products: allProducts });
        if (this.state.iswaiting === true) {
            this.setState({ iswaiting: false })
        }
    }

    productsVisible: boolean = false;

    getProductItems() {
        this.productsVisible = false;
        if (this.state.product)
            return;

        if (!this.state.Products) {
            return;
        }

        if (!this.state.BrandsDict) {
            return;
        }

        var products = new Array();
        if (this.state.Products.length == 0) {
            var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize: '24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center' };
            products.push(<div key="none" style={noItemsStyle}>No matching items</div>);
        }

        var addSeparator = false;
        var separatorAdded = false;
        for (var i in this.state.Products) {
            var product: Tgcc.Product = this.state.Products[i];
            var brand: Tgcc.ProductBrand = this.state.BrandsDict[product.brand];
            if (product.designation)
                addSeparator = true;
            else if (addSeparator && !separatorAdded && !product.designation) {
                var hrId = "des_hr_" + i;
                var divId = "des_div_" + i;
                products.push(<div key={divId} style={Tgcc.Styles.dividerBreak}><hr key={hrId} style={Tgcc.Styles.dividerStyle} /></div>);
                separatorAdded = true;
            }
            products.push(<RealCampusProductCard key={"product_" + i} product={product} brand={brand} onSelect={this.handleProductSelection} />);
        }
        this.productsVisible = true;
        return products;
    }

    handleBackToProof = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None })
    }

    handleProductSelection = (product: Tgcc.Product) => {
        var scroller = document.getElementById("Scroller");
        var el = document.getElementById("campusProdCat");
        if (el != null) {
            scroller.scrollTop = el.offsetTop - 125;
        }
        product.displayIndex = 0;
        this.setState({ product: product, selectedSwatch: product });
        if (product.brand === 'Outer Banks') {
            this.setState({ StyleSet: OB_STYLE_SET });
            return;
        }
        TgccRequest.getProductStyleSet(product, this.productStyleSetLoaded);
    }

    productStyleSetLoaded = (products: Tgcc.Product[]) => {
        this.setState({ StyleSet: products });
    }

    handleProductImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    handleSwatchImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
        event.currentTarget.style.backgroundColor = '#123456';
    }

    selectedImageStyle: CSSProperties = {
        width: 'auto',
        maxWidth: '250px',
        maxHeight: '250px',
        alignSelf: 'center',
        cursor: 'zoom-in',
        '@media (max-width:320px)': {
            maxWidth: '125px'
        }
    }

    zoomProduct = () => {
        this.setState({ zoomProduct: this.state.selectedSwatch });
    }
    zoomSpecificProduct = (product: Tgcc.Product) => {
        this.setState({ zoomProduct: product, selectedSwatch: product });
    }
    hideFullSizeProduct = () => {
        this.setState({ zoomProduct: null });
    }

    getselectedSwatch() {
        if (this.state.selectedSwatch && this.state.selectedSwatch.brand === 'Outer Banks') {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                    <img
                        src={OB_IMG_1}
                        style={{ ...this.selectedImageStyle as any, cursor: 'zoom-in' }}
                        onClick={() => this.zoomSpecificProduct(OB_PRODUCT)}
                        onError={this.handleProductImageError} />
                    <img
                        src={OB_IMG_2}
                        style={{ ...this.selectedImageStyle as any, cursor: 'zoom-in' }}
                        onClick={() => this.zoomSpecificProduct(OB_PRODUCT_VIEW2)}
                        onError={this.handleProductImageError} />
                </div>
            );
        }
        return (
            <img
                src={Tgcc.getProductPath(this.state.selectedSwatch.thumbnail)}
                style={this.selectedImageStyle}
                onClick={this.zoomProduct}
                onError={this.handleProductImageError}
                className="selectedImageStyle" />)
    }

    getProductStyleSwatches() {
        if (!this.state.StyleSet)
            return;

        var styles = new Array();
        var seenColors = new Set<string>();
        for (var i in this.state.StyleSet) {
            var product: Tgcc.Product = this.state.StyleSet[i];
            product.displayIndex = Number(i);
            // For OB, only render one swatch per color — images are shown inline
            if (product.brand === 'Outer Banks') {
                if (seenColors.has(product.colorName)) continue;
                seenColors.add(product.colorName);
            }
            styles.push(<ProductSwatch
                key={product.brand + product.style + product.colorName + '_' + product.displayIndex}
                product={product}
                selected={this.state.selectedSwatch}
                callback={this.handleSwatchClick} />)
        }
        return styles;
    }

    getProductDetail = () => {
        if (!this.state.product)
            return;

        if (!this.state.StyleSet)
            return;

        var detailStyle: CSSProperties = {
            width: '800px',
            minHeight: '400px',
            marginBottom: '20px',
            boxShadow: Tgcc.Styles.boxShadow,
            backgroundColor: 'white',
            fontFamily: 'CenturyGothic',
            padding: '5px 30px 15px 30px',
            position: 'relative'
        };

        var brandStyle: CSSProperties = {
            textAlign: 'center',
            fontSize: '40px',
            lineHeight: '40px',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            fontFamily: 'BarlowLight',
            color: '#606060',
            '@media (max-width:414px)': {
                fontSize: '20px'
            },
            '@media (max-width:320px)': {
                fontSize: '16px'
            }
        };

        var boxStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            width:'625px'
        };
        var currentStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            maxWidth: '300px',
            maxHeight: '90%',
            margin: '50px 0',
            flexShrink: 1,
            alignSelf: 'center',
            padding: '25px',
            backgroundColor: 'white',
            '@media (max-width:414px)': {
                margin: '25px 0'
            }
        };

        var swatchesStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'row',
            flexFlow: 'wrap',
            justifyContent: 'center',
            cursor: 'pointer',
            alignSelf: 'center',
            flexShrink: 1,
            maxWidth: '330px',
            margin: '20px 0',
        };

        var footerStyle: CSSProperties = {
            display: 'flex',
            justifyContent: 'space-around',
        };

        var colorStyle: CSSProperties = {
            fontSize: '26px',
            width: '100%',
            letterSpacing: '2px',
            fontFamily: 'BarlowLight',
            color: '#606060',
            textAlign: 'center',
            '@media (max-width:320px)': {
                fontSize: '12px'
            }
        };

        var detailHdrStyle: CSSProperties = {
            fontSize: '15px',
            width: '100%',
            textTransform: 'uppercase',
            marginTop: '10px',
            textAlign: 'center',
            '@media (max-width:320px)': {
                fontSize: '12px'
            }
        }
        var detailStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            fontSize: '15px',
            width: '100%',
            position: 'relative',
            marginTop: '40px',
            right:'16%'
        }
        var prodInfo: CSSProperties = {
            color: '#606060'
        }
        var style: CSSProperties = {
            fontFamily: 'BarlowLight',
            color: '#606060',
            width: '100%'
        }
        var popUpDetail: CSSProperties = {
            position: 'fixed',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22, 22, 22, 0.5)',
            placeContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden auto'
        }
        var brandStyle1: CSSProperties = {
            textAlign: 'center',
            fontSize: '40px',
            lineHeight: '40px',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            fontFamily: 'AveriaSerifLight',
            color: 'white',
            '@media (max-width:414px)': {
                fontSize: '20px'
            },
            '@media (max-width:320px)': {
                fontSize: '16px'
            }
        };

        var description = this.state.selectedSwatch ? this.state.selectedSwatch.description : null;
        var features = this.state.selectedSwatch ? this.state.selectedSwatch.features : null;
        var specs = this.state.selectedSwatch ? this.state.selectedSwatch.specs : null;

        var selectedColor = this.state.selectedSwatch ? this.state.selectedSwatch.colorName : null;
        let btnStyle = Object.assign({}, Tgcc.Styles.grayButton, { width: '225px', height: '30px', lineHeight: "30px", margin: '5px 0', fontFamily: 'Lulo' });
        let btnStyle1 = Object.assign({}, Tgcc.Styles.grayButton, { width: '25%', height: '17px', lineHeight: "17px", margin: '5px 0', fontFamily: 'Lulo' });
        let btnStyle2 = Object.assign({}, Tgcc.Styles.grayButton, { width: '175px', height: '17px', lineHeight: "17px", margin: '5px 0', fontFamily: 'Lulo' });
        return (
            <div style={detailStyle} className="campusProductDetailCont">
                <div style={brandStyle} className="brandStyle">{this.state.product.brand}-{this.state.product.style}</div>
                <div style={boxStyle} className="campBoxStyle">
                    <div className="productImgStyle" style={currentStyle}>
                        {this.getselectedSwatch()}
                        <div className="colorStyle" style={colorStyle}>{selectedColor}</div>
                    </div>
                    <div className="swatchesStyle" style={swatchesStyle}>

                        <div style={style}>
                            <div style={detailHdrStyle}>Product Description</div>
                            <ul>
                                <li style={prodInfo}>{description}</li>
                                <li style={prodInfo}>{features}</li>
                                <li style={prodInfo}>{specs}</li>
                            </ul>
                            <div>Color:<i>{selectedColor}</i></div>
                        </div>
                        {this.getProductStyleSwatches()}

                    </div>

                </div>
                <div style={footerStyle}>
                    <div className="grayButton campusBackProductBtn" style={btnStyle} onClick={this.handleDetailBackButton}>Back</div>
                    <div className="grayButton campusAddProductBtn" style={btnStyle} onClick={this.handleDetailAddButton}>add to proof</div>
                </div>
            </div>
        )

    }

    getFullSizeProductPopup = () => {
        if (!this.state.selectedSwatch)
            return;

        if (!this.state.zoomProduct)
            return;

        let product: Tgcc.Product = this.state.zoomProduct;

        let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            alignContent: 'center',
            alignSelf: 'center',
            width: '800px',
            height: '1000px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin: '30px auto'
            },
            '@media (max-width:375px)': {
                maxWidth: '80%',
                maxHeight: '70%'
            }

        };

        let imgStyle: CSSProperties = {
            position: 'relative',
            maxWidth: '80%',
            maxHeight: '75%',
            width: 'auto',
            height: 'auto',
            alignSelf: 'center',
            cursor: 'zoom-out',
        };


        let footerStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%'
        }
        let addStyle: CSSProperties = {
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid none',
            fontSize: '14px',
            lineHeight: '30px',
            fontFamily: 'Lulo',
            textTransform: 'uppercase',
            width: '200px',
            cursor: 'pointer',
            display: 'flex',
            alignSelf: 'center',
            justifyContent: 'center',
            color: '#606060'
        };
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }

        return (
            <ScreenDoor>
                <div style={fullSizeStyle}>
                    <CloseX closeAction={this.hideFullSizeProduct} />
                    <img style={imgStyle} src={Tgcc.getProductPath(product.image)} onClick={this.hideFullSizeProduct} />
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.setPreviousSwatch}>&lsaquo;</div>
                        <div className="hoverBorder" style={addStyle} onClick={this.handleDetailAddButton}>add to proof</div>
                        <div style={arrowStyle} onClick={this.setNextSwatch}>&rsaquo;</div>
                    </div>
                </div>
            </ScreenDoor>
        )
    }

    setPreviousSwatch = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.selectedSwatch.displayIndex - 1;
        curIndex = curIndex < 0 ? this.state.StyleSet.length - 1 : curIndex;
        var prev = this.state.StyleSet[curIndex];
        this.setState({ selectedSwatch: prev, zoomProduct: prev });
    }

    setNextSwatch = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.selectedSwatch.displayIndex + 1;
        curIndex = curIndex >= this.state.StyleSet.length ? 0 : curIndex;
        var next = this.state.StyleSet[curIndex];
        this.setState({ selectedSwatch: next, zoomProduct: next });
    }

    handleDetailBackButton = () => {
        this.setState({ product: null });
    }
    handleDetailBackButton1 = () => {
        this.setState({ product: null });
        browserHistory.goBack();
    }
    handleDetailBackButton2 = () => {
        this.setState({ product: null });
        browserHistory.push(Tgcc.Routes.CampusProductListView)
    }

    handleDetailAddButton = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        if (this.props.state.LoginData && this.props.state.UserInfo) {
            this.props.dispatch({ type: Tgcc.StateAction.UpdateCampusProofProduct, payload: this.state.selectedSwatch });
        }
        else {
            browserHistory.push(Tgcc.Routes.CampusRegister);
        }
    }

    handleSwatchClick = (swatchProduct: Tgcc.Product) => {
        this.setState({ selectedSwatch: swatchProduct });
    }

    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if (evt.keyCode == 13) { // return keyCode
            var filter: string = evt.currentTarget.value;
            this.toggleFilterValue("filter", filter);
        }

        var style = evt.currentTarget.attributes['style'];
        if (style && style.value) {
            if (evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px', 'letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px', 'letter-spacing: 6px');
        }
    }

    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value; // make sure "" is set to null
        if (this.state.filter != srchComp) {
            this.toggleFilterValue("filter", srch.value);
        }
    }

    closeSelector = () => {
        this.handleBackToProof();
    }
    onSubmit(e) {
        console.log('submitting...');
        e.preventDefault();
    }

    getIsMobile(): boolean {
        var Android = function () { return navigator.userAgent.match(/Android/i); };
        var BlackBerry = function () { return navigator.userAgent.match(/BlackBerry/i); };
        var iOS = function () { return navigator.userAgent.match(/iPhone|iPad/i); };
        var Opera = function () { return navigator.userAgent.match(/Opera Mini|Opera Mobi/i); };
        var Windows = function () { return navigator.userAgent.match(/IEMobile/i); };

        return (Android() || BlackBerry() || iOS() || Opera() || Windows()) != null;
    }

    getSearchBlock(isMobile: boolean) {
        if (isMobile) {
            return
            <form style={searchFormStyle} onSubmit={this.onSubmit}>
                <input type="text" style={searchStyle} className="searchStyle" placeholder="Search" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch} />
                <input style={searchBtn} type="submit" value="" />
            </form>
        } else {
            return <input type="text" style={searchStyle} placeholder="Search Products" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch} />
        }
    }

    openProofEdit = () => { browserHistory.push(Tgcc.Routes.CampusProofEdit) }

    clearFilters() {
        var data: any = {
            categories: null,
            brand: null,
            filter: null,
            priceCategory: null,
            genderAge: null,
            sleeve: null,
            styleType: null,
            fabric: null,
            weight: null,
            uniqueSize: null,
            newItem: false,
            favorite: false,
            sort: null
        };

        this.applyFilter(data);
    }

    applyFilter(data: any) {
        data.productReqTime = data.filterReqTime = new Date().getTime();

        TgccRequest.findProducts(data.productReqTime,
            DIVISION,
            data.categories,
            data.brand,
            data.filter,
            null,
            null,
            data.priceCategory,
            data.genderAge,
            data.sleeve,
            data.styleType,
            data.fabric,
            data.weight,
            data.uniqueSize,
            data.newItem,
            data.favorite,
            data.sort,
            (productReqTime: number, products: Tgcc.Product[]) => {
                if (this.productRequestIsCurrent(productReqTime))
                    this.productsLoaded(products);
                else
                    console.log("Product query result discarded: ", products.length);
            });

        TgccRequest.getFilterCounts(data.filterReqTime,
            DIVISION,
            data.categories,
            data.brand,
            data.filter,
            data.priceCategory,
            data.genderAge,
            data.sleeve,
            data.styleType,
            data.fabric,
            data.weight,
            data.uniqueSize,
            data.newItem,
            data.favorite,
            (filterReqTime: number, counts: Map<string, Map<string, number>>) => {
                if (this.filterRequestIsCurrent(filterReqTime))
                    this.setState({ filterCounts: counts });
                else
                    console.log("filter count discared as late {filterReqTime}")
            });

        this.setState(data);
    }

    productRequestIsCurrent = (productReqTime: number): boolean => {
        return this.state.productReqTime == productReqTime;
    }

    filterRequestIsCurrent = (filterReqTime: number): boolean => {
        return this.state.filterReqTime == filterReqTime;
    }

    toggleFilterValue(name: string, value: any, checked: boolean = false) {
        var data: any = {
            categories: this.state.categories,
            brand: this.state.brand,
            filter: this.state.filter,
            priceCategory: this.state.priceCategory,
            genderAge: this.state.genderAge,
            sleeve: this.state.sleeve,
            styleType: this.state.styleType,
            fabric: this.state.fabric,
            weight: this.state.weight,
            uniqueSize: this.state.uniqueSize,
            newItem: this.state.newItem,
            favorite: this.state.favorite,
            sort: this.state.sort
        };
        if (name == 'recommendation') {
            data[value] = checked;
        } else {
            // update specified value
            if (!data[name])
                data[name] = new Array<string>();

            if (!checked) {
                let loc = data[name].indexOf(value);
                if (loc > -1)
                    data[name].splice(loc, 1);
            }
            else {
                data[name].push(value);
            }
        }

        this.applyFilter(data);
    }

    clearFilterSet(name: string) {
        var data: any = {
            categories: this.state.categories,
            brand: this.state.brand,
            filter: this.state.filter,
            priceCategory: this.state.priceCategory,
            genderAge: this.state.genderAge,
            sleeve: this.state.sleeve,
            styleType: this.state.styleType,
            fabric: this.state.fabric,
            weight: this.state.weight,
            uniqueSize: this.state.uniqueSize,
            newItem: this.state.newItem,
            favorite: this.state.favorite,
            sort: this.state.sort
        };

        if (name == 'recommendation') {
            data['newItem'] = false;
            data['favorite'] = false;
        } else {
            data[name] = null;
        }

        this.applyFilter(data);
    }

    getDivider(keynum: number) {
        return <hr key={'Divider_' + keynum} width='230px' marginHeight={0} />
    }

    getPredefinedFilters() {
        var dividerCt = 0;
        var filters = new Array();
        if (this.state.ProductCategories) {
            var catMap: Map<string, number> = new Map<string, number>();
            this.state.ProductCategories.forEach(pc => catMap.set(pc.category, pc.id));
            filters.push(<FilterGroup key="categories" groupLabel="Categories" groupName="Category" expanded={true} counts={this.state.filterCounts["categories"]} filters={catMap} state={this.state.categories} setFilter={(value: string, checked: boolean) => this.toggleFilterValue("categories", value, checked)} clearAll={() => this.clearFilterSet("categories")} />);
            filters.push(this.getDivider(dividerCt++))
        }

        if (this.state.ProductBrands) {
            var brandsMap: Map<string, string> = new Map<string, string>();
            this.state.ProductBrands.forEach(b => brandsMap.set(b.brand, b.brand));
            filters.push(<FilterGroup key="brands" groupLabel="Brands" groupName="Brand" expanded={false} counts={this.state.filterCounts["brands"]} filters={brandsMap} state={this.state.brand} setFilter={(value: string, checked: boolean) => this.toggleFilterValue("brand", value, checked)} clearAll={() => this.clearFilterSet("brand")} />)
            filters.push(this.getDivider(dividerCt++));
        }
        //No used anymore
        var prices: Map<string, string> = new Map<string, string>();
        prices.set("$", "$");
        prices.set("$$", "$$");
        prices.set("$$$", "$$$");


        var genders: Map<string, string> = new Map<string, string>();
        genders.set("Mens/Unisex", "Mens/Unisex");
        genders.set("Ladies", "Ladies");


        var sleeves: Map<string, string> = new Map<string, string>();
        sleeves.set("SS", "SS");
        sleeves.set("LS", "LS");


        var fabrics: Map<string, string> = new Map<string, string>();
        fabrics.set("Performance", "Performance");
        fabrics.set("100% Cotton", "100% Cotton");
        fabrics.set("Poly/Cotton Blend", "Poly/Cotton Blend");
        fabrics.set("Triblend", "Triblend");


        var weights: Map<string, string> = new Map<string, string>();
        weights.set("Light Weight", "Light Weight");
        weights.set("Mid Weight", "Mid Weight");
        weights.set("Heavy Weight", "Heavy Weight");


        var styles: Map<string, string> = new Map<string, string>();
        styles.set("Raglan", "Raglan");
        styles.set("Hoodie", "Hoodie");
        styles.set("Quarter Zip", "Quarter Zip");
        styles.set("V-Neck", "V-Neck");
        styles.set("Pocket", "Pocket");
        styles.set("Tanks", "Tanks");
        styles.set("Henley", "Henley");
        styles.set("Crewneck", "Crewneck");

        var sizes: Map<string, string> = new Map<string, string>();
        sizes.set("XSmall", "XSmall");
        sizes.set("4XLarge", "4XLarge");
        sizes.set("5XLarge", "5XLarge");
        sizes.set("6XLarge", "6XLarge");

        return filters;
    }

    getCategoryName(id: number) {
        return this.state.ProductCategories.find((cat) => cat.id == id).category;
    }

    getActiveFilters() {
        var activeFilters = new Array();

        if (this.state.favorite)
            activeFilters.push(<FilterBubble key="fav_filter" groupName="Recommended" value="favorite" label="Staff picks" removeFilter={(value: string) => this.toggleFilterValue("recommendation", value, false)} />);

        if (this.state.newItem)
            activeFilters.push(<FilterBubble key="newItem_filter" groupName="Recommended" value="newItem" label="New items" removeFilter={(value: string) => this.toggleFilterValue("recommendation", value, false)} />);

        var i: number = 0;
        if (this.state.categories) {
            this.state.categories.forEach((catId) => {
                var prodCat: string = this.getCategoryName(catId);
                activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Category" value={catId} label={prodCat} removeFilter={(value: string) => this.toggleFilterValue("categories", value, false)} />);
            });
        }

        if (this.state.brand) {
            this.state.brand.forEach((brand) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Brand" value={brand} label={brand} removeFilter={(value: string) => this.toggleFilterValue("brand", value, false)} />));
        }

        if (this.state.priceCategory) {
            this.state.priceCategory.forEach((price) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Price" value={price} label={price} removeFilter={(value: string) => this.toggleFilterValue("priceCategory", value, false)} />));
        }

        if (this.state.genderAge) {
            this.state.genderAge.forEach((gender) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Gender/Age" value={gender} label={gender} removeFilter={(value: string) => this.toggleFilterValue("genderAge", value, false)} />));
        }

        if (this.state.sleeve) {
            this.state.sleeve.forEach((sleeve) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Sleeve" value={sleeve} label={sleeve} removeFilter={(value: string) => this.toggleFilterValue("sleeve", value, false)} />));
        }

        if (this.state.fabric) {
            this.state.fabric.forEach((fabric) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Fabric" value={fabric} label={fabric} removeFilter={(value: string) => this.toggleFilterValue("fabric", value, false)} />));
        }

        if (this.state.weight) {
            this.state.weight.forEach((wt) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Weight" value={wt} label={wt} removeFilter={(value: string) => this.toggleFilterValue("weight", value, false)} />));
        }

        if (this.state.styleType) {
            this.state.styleType.forEach((style) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Style" value={style} label={style} removeFilter={(value: string) => this.toggleFilterValue("styleType", value, false)} />));
        }

        if (this.state.uniqueSize) {
            this.state.uniqueSize.forEach((sz) => activeFilters.push(<FilterBubble key={'filter_' + i++} groupName="Size" value={sz} label={sz} removeFilter={(value: string) => this.toggleFilterValue("uniqueSize", value, false)} />));
        }

        if (activeFilters.length)
            activeFilters.push(<div key="clear_filter" className="clearAll" style={clearAllStyle} onClick={() => this.clearFilters()}>clear all</div>);

        return activeFilters;
    }

    selectSort(evt: any) {
        if (evt) {
            var sel: HTMLSelectElement = evt.currentTarget;
            if (sel.selectedOptions.length > 0) {
                var opt: HTMLOptionElement = sel.selectedOptions[0];
                if (opt.value) {
                    this.applySort(opt.value);
                }
            }
        }
    }

    applySort(sortVal: string) {
        var data: any = {
            productReqTime: new Date().getTime(),
            categories: this.state.categories,
            brand: this.state.brand,
            filter: this.state.filter,
            priceCategory: this.state.priceCategory,
            genderAge: this.state.genderAge,
            sleeve: this.state.sleeve,
            styleType: this.state.styleType,
            fabric: this.state.fabric,
            weight: this.state.weight,
            uniqueSize: this.state.uniqueSize,
            newItem: this.state.newItem,
            favorite: this.state.favorite,
            sort: sortVal
        };

        TgccRequest.findProducts(data.productReqTime,
            DIVISION,
            data.categories,
            data.brand,
            data.filter,
            null,
            null,
            data.priceCategory,
            data.genderAge,
            data.sleeve,
            data.styleType,
            data.fabric,
            data.weight,
            data.uniqueSize,
            data.newItem,
            data.favorite,
            data.sort,
            (productReqTime: number, products: Tgcc.Product[]) => {
                if (this.productRequestIsCurrent(productReqTime))
                    this.productsLoaded(products)
                else
                    console.log("Product query result discarded: ", products.length);
            });

        this.setState(data);
    }

    render() {
        var isMobile = this.getIsMobile();
        var searchBlock = this.getSearchBlock(isMobile);
        var filtersBlock = this.getPredefinedFilters();
        var products = this.state.iswaiting ? <Tgcc.LoadingElement /> : this.getProductItems();
        return (

            <div>
                <div id="campusProducts"></div>
                <CampusHeader />
                <CampusFeedback state={this.props.state} />
                <div key="productContent" style={contentDiv} className="campusProductContent">
                    <div key="4" style={categoryContainerOuterStyle} className="campusProductCat">
                        <div key="backToProof" style={backToProofBtn} className='backtoProofBtn' onClick={this.openProofEdit}>&laquo; Back to Proof</div>
                        <div key="cetegoryContainer" style={categoryContainerStyle}>
                            {searchBlock}
                            {filtersBlock}
                        </div>

                    </div>
                    <div key="catalogOuter" style={catalogOuterStyle} className='campusProdCat' id="campusProdCat">
                        <div key="activeFilters" style={activeFiltersStyle}>
                            {this.getActiveFilters()}
                        </div>
                        <select style={sortSelectStyle} defaultValue={this.state.sort} placeholder="Sort by" onChange={(evt) => this.selectSort(evt)}>
                            <option value={Tgcc.SortOrders.Default}>{Tgcc.SortOrders.Default}</option>
                            <option value={Tgcc.SortOrders.AtoZ}>{Tgcc.SortOrders.AtoZ}</option>
                            <option value={Tgcc.SortOrders.ZtoA}>{Tgcc.SortOrders.ZtoA}</option>
                            <option value={Tgcc.SortOrders.LowToHigh}>{Tgcc.SortOrders.LowToHigh}</option>
                            <option value={Tgcc.SortOrders.HighToLow}>{Tgcc.SortOrders.HighToLow}</option>
                        </select>
                        <div key="catalog" style={catalogStyle} className='campusProdCat'>
                            {products}
                        </div>
                    </div>
                    {this.getProductDetail()}
                    {this.getFullSizeProductPopup()}
                </div>
                <CampusFooter state={this.props.state} />
            </div>
        )
    }
}

var CampusproductListView = Radium(_CampusProductListView);
const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        proof: state.ActiveProof,
        searchFilter: state.FilterProductsBySearch,
        state: state
    }
};

export var CampusProductListView = connect(mapStateToProps)(CampusproductListView);